// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditName h2:hover{border-bottom:1px solid gray;cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/Misc/EditName.scss"],"names":[],"mappings":"AACI,mBACI,4BAAA,CACA,cAAA","sourcesContent":[".EditName {  \n    h2:hover{\n        border-bottom: 1px solid grey;\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
